import React, { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import AdminLayout from "../../../components/Admin/Layout";
import Customers from "../../../components/Admin/Verification/Customers";
import Certificates from "../../../components/Admin/Verification/Certificates";

const pathPrefix = "/admin/verifications";

const AdminVerificationPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname !== pathPrefix) return;
    navigate(`${pathPrefix}/customers`);
  }, [location.pathname]);

  return (
    <AdminLayout
      title={"Verifications"}
      tabs={[
        { id: 0, title: "Customers", path: `${pathPrefix}/customers` },
        { id: 0, title: "Certificates", path: `${pathPrefix}/certificates` },
      ]}
    >
      <Routes>
        <Route path="/customers" element={<Customers />} />
        <Route path="/certificates" element={<Certificates />} />
      </Routes>
    </AdminLayout>
  );
};

AdminVerificationPage.propTypes = {};

export default AdminVerificationPage;
